var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1598.46 1273.95",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1112.91 945.38-85.12 85.19 85.12 85.19 85.13-85.19z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1143.22 1000.24h-60.62v60.66h60.62z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m939.04 1148.08-57.72 57.76 57.72 57.77 57.72-57.77z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m959.59 1185.28h-41.1v41.13h41.1z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1359.73 120.9v119.4h119.4a120.6 120.6 0 0 0 120.6-120.6v-119.4h-119.39a120.6 120.6 0 0 0 -120.61 120.6z",
    opacity: 0.08,
    transform: "translate(-2.37 -.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1411.59 120.3a70.56 70.56 0 0 0 141.11 0v-70.55h-70.55a70.55 70.55 0 0 0 -70.56 70.55z",
    opacity: 0.05,
    transform: "translate(-2.37 -.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1359.73 192.9v48h48a72 72 0 0 0 72-72v-48h-48a72 72 0 0 0 -72 72z",
    opacity: 0.05,
    transform: "translate(-2.37 -.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 201.78,
    cy: 215.61,
    opacity: 0.08,
    rx: 100.84,
    ry: 100.79
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.86 96.21c0 66-53.33 119.41-119.12 119.41 0-65.95 53.33-119.41 119.12-119.41z",
    opacity: 0.05,
    transform: "translate(-2.37 -.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203 212.14v3.48h-3.5c-63.87 0-115.64-51.91-115.64-115.93v-3.48h3.47c63.87 0 115.67 51.9 115.67 115.93z",
    opacity: 0.05,
    transform: "translate(-2.37 -.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.5 216.8h3.5v3.48c0 64-51.77 115.93-115.64 115.93h-3.5v-3.48c0-64.03 51.77-115.93 115.64-115.93z",
    opacity: 0.05,
    transform: "translate(-2.37 -.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.86 332.73v3.48h-3.47c-63.87 0-115.65-51.91-115.65-115.93v-3.48h3.47c63.87 0 115.65 51.9 115.65 115.93z",
    opacity: 0.05,
    transform: "translate(-2.37 -.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.17,
    cy: 1149.95,
    opacity: 0.08,
    r: 100.84
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.37 -.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.36 1209.28a116.49 116.49 0 0 1 39.91-159.85l3-1.8 1.79 3a116.5 116.5 0 0 1 -39.91 159.86l-3 1.8z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195 1250.39 1.8 3-3 1.8a116.5 116.5 0 0 1 -159.8-39.91l-1.8-3 3-1.8a116.51 116.51 0 0 1 159.8 39.91z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.84 1153.5-1.8-3 3-1.8a116.51 116.51 0 0 1 159.86 39.91l1.8 3-3 1.79a116.49 116.49 0 0 1 -159.86-39.9z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.94 988.85a116.5 116.5 0 0 1 -39.94 159.86l-3 1.8-1.8-3a116.49 116.49 0 0 1 39.91-159.85l3-1.8z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1600.83 1034.26-2.2 240-240-2.21c1.22-132.55 109.66-239.05 242.2-237.79z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1599.88 1138-1.25 136.21-136.55-1.21c.69-75.23 62.39-135.65 137.8-135z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1599.2 1211.75-.57 62.5-62.66-.58a62.58 62.58 0 0 1 63.23-61.92z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.37 241.81v-240h240c0 132.54-107.45 240-240 240z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.37 138.36v-136.55h136.22c0 75.41-60.99 136.55-136.22 136.55z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.37 64.47v-62.66h62.51a62.59 62.59 0 0 1 -62.51 62.66z",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m431.88 602.91-85.12-85.19 85.12-85.18 85.13 85.18z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.88 560.62-42.86-42.9 42.86-42.89 42.87 42.89z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m791.87 326.89-62.34-62.38 62.34-62.38 62.33 62.38z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m814.06 286.72h-44.39v-44.42h44.39z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.37 -.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m609.78 141.49-3.36 90.41-90.42-3.36a90.47 90.47 0 0 1 -87-93.77l3.36-90.41 90.41 3.36a90.47 90.47 0 0 1 87.01 93.77z",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "m570.71 140a53.19 53.19 0 1 1 -106.3-3.95l2-53.16 53.16 2a53.18 53.18 0 0 1 51.14 55.11z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m607.75 196.19-1.35 36.16-36.16-1.35a54.27 54.27 0 0 1 -52.24-56.25l1.34-36.17 36.16 1.35a54.28 54.28 0 0 1 52.25 56.26z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.63 1181.92v-79.6h79.6a80.42 80.42 0 0 1 80.42 80.41v79.61h-79.65a80.42 80.42 0 0 1 -80.37-80.42z",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.2 1182.33a47 47 0 0 1 94.09 0v47h-47.05a47 47 0 0 1 -47.04-47z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.63 1133.92v-32h32a48 48 0 0 1 48 48v32h-32a48 48 0 0 1 -48-48z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1271.06 164.3a57.56 57.56 0 1 1 0-115.12h57.56v57.56a57.56 57.56 0 0 1 -57.56 57.56z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1294.2 118a34.42 34.42 0 0 1 0-68.84h34.42v34.44a34.42 34.42 0 0 1 -34.42 34.4z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1271.06 142.46a35.15 35.15 0 1 1 35.14-35.14 35.14 35.14 0 0 1 -35.14 35.14z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1271.06 127.89a20.58 20.58 0 1 1 20.57-20.57 20.57 20.57 0 0 1 -20.57 20.57z",
    opacity: 0.06
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP31);
export default __webpack_public_path__ + "static/media/p31.7f34d9a5af3b4602a7ae198d1dd6f630.svg";
export { ForwardRef as ReactComponent };